import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppFooter } from '../components/layout/AppFooter';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const navigate = useNavigate();

  async function loginSession(e: React.FormEvent) {
    e.preventDefault();
    setMessage(null);
    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
        credentials: 'include',
      });
      if (!res.ok) throw new Error('Invalid credentials');
      await res.json();
      navigate('/home');
    } catch (err: any) {
      setMessage(err.message || 'Login failed');
    }
  }

  return (
    <div className="flex min-h-screen flex-col items-center p-6">
      <div className="flex w-full max-w-sm flex-1 flex-col justify-center">
        <div className="w-full rounded-lg border p-6">
          <h1 className="mb-4 text-2xl font-semibold">Sign in</h1>
          <form className="space-y-4" onSubmit={loginSession}>
            <div className="grid gap-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <Button type="submit" className="w-full">
              Login
            </Button>
          </form>
          <div className="mt-3 text-right">
            <a href="/forgot" className="text-sm text-blue-600 hover:underline">
              Forgot password?
            </a>
          </div>
          {message && <p className="mt-4 text-sm text-muted-foreground">{message}</p>}
        </div>
      </div>
      <div className="w-full max-w-sm shrink-0 pt-4">
        <AppFooter />
      </div>
    </div>
  );
}
